<template>
  <div class="testimonials">
    <div class="header">
      <div>
        <h2>{{ label_testimonials }}</h2>
        <p>We would love to hear your feedback on the MasterFit Roof Box 530L (Black)</p>
      </div>
      <div>
        <a href @click.prevent="writeReview" class="btn btn-hover btn-white-blue">
          <img src="/cdn/images/temp/pen.svg" alt />
          <span>{{ label_write_review }}</span>
        </a>
      </div>
    </div>

    <div class="testimonial" v-for="(testimonial, index) in testimonials" :key="index">
      <div class="quote">
        <img src="/cdn/images/temp/quote.svg" alt />
      </div>
      <div class="main">
        <div class="text">
          <p>{{ testimonial.text }}</p>
        </div>
        <div class="meta">
          <span class="author">{{ testimonial.author }}</span>
          <span class="date">{{ testimonial.date }}</span>
        </div>
      </div>
    </div>

    <a
      @click.prevent="loadMore"
      v-show="showLoadMoreButton"
      href
      class="btn btn-hover btn-white-blue"
    >{{ label_load_more }}</a>

    <modal name="write-review" :adaptive="true" height="auto">
      <h3>{{ label_write_review }}</h3>
      <textarea name id rows="5" v-model="newReview.text"></textarea>
      <button class="btn btn-primary btn-hover" @click="addReview">{{ label_submit_review }}</button>
    </modal>
  </div>
</template>

<script>
export default {
  name: "testimonials",
  props: {
      // NOTE: these aren't in the language files because this module has been discontinued
    label_testimonials: {
      type: String,
      default: "Testimonials"
    },
    label_submit_review: {
      type: String,
      default: "Submit review"
    },
    label_write_review: {
      type: String,
      default: "Write a review"
    },
    label_load_more: {
      type: String,
      default: "Load More"
    }    
  },
  data() {
    return {
      numberToLoad: 2,
      newReview: {
        text: "",
        author: "Drew Kennelly",
        date: "October 2019"
      },
      data: [
        {
          text:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus accusamus obcaecati voluptates expedita, dignissimos pariatur cupiditate praesentium mollitia quo, commodi fuga libero odit quae ratione tempore unde nisi voluptatibus aliquid! Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus accusamus obcaecati voluptates expedita, dignissimos pariatur cupiditate praesentium mollitia quo, commodi fuga libero odit quae ratione tempore unde nisi voluptatibus aliquid!",
          author: "John Smith",
          date: "July 2019"
        },
        {
          text:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus accusamus obcaecati voluptates expedita, dignissimos pariatur cupiditate praesentium mollitia quo, commodi fuga libero odit quae ratione tempore unde nisi voluptatibus aliquid! Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus accusamus obcaecati voluptates expedita, dignissimos pariatur cupiditate praesentium mollitia quo, commodi fuga libero odit quae ratione tempore unde nisi voluptatibus aliquid! Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus accusamus obcaecati voluptates expedita",
          author: "Jane Smith",
          date: "June 2019"
        },
        {
          text:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus accusamus obcaecati voluptates expedita, dignissimos pariatur cupiditate praesentium mollitia quo, commodi fuga libero odit quae ratione tempore unde nisi voluptatibus aliquid! Lorem ipsum dolor sit amet consectetur adipisicing elit. ",
          author: "Peter Smith",
          date: "May 2019"
        },
        {
          text:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus accusamus obcaecati voluptates expedita, dignissimos pariatur cupiditate praesentium mollitia quo.",
          author: "David Smith",
          date: "April 2019"
        }
      ]
    };
  },
  computed: {
    testimonials() {
      return this.data.slice(0, this.numberToLoad);
    },
    showLoadMoreButton() {
      return this.data.length > this.numberToLoad ? true : false;
    }
  },
  methods: {
    loadMore() {
      this.numberToLoad += 2;
    },
    writeReview() {
      this.newReview.text = "";
      this.$modal.show("write-review");
    },
    addReview() {
      this.data.unshift(this.newReview);
      this.$modal.hide("write-review");
    }
  }
};
</script>
